import IcoChat from '../icons/IcoChat'
import IcoPin from '../icons/IcoPin'
import IcoHeart from '../icons/IcoHeart'
import IcoPlane from '../icons/IcoPlane'

export const REASONS = [
  {
    'codigo': 'F',
    'texto': 'Questões financeiras',
    'submotivos': [
      { 'codigo': 'CORTE_GASTOS', 'texto': 'Preciso reduzir gastos' },
      { 'codigo': 'VALOR_ALTO', 'texto': 'O valor da assinatura está alto para mim' },
      { 'codigo': 'CUSTO_BENEFICIO', 'texto': 'Não considero que o benefício justifique o valor' },
      { 'codigo': 'FORMA_PAGAMENTO', 'texto': 'As formas de pagamento não me atendem' }
    ]
  },
  {
    'codigo': 'S',
    'texto': 'Falta de tempo para aproveitar a assinatura',
    'submotivos': [
      { 'codigo': 'A', 'texto': 'Estou acumulando livros não lidos' },
      { 'codigo': 'S', 'texto': 'Estou sem tempo para ler' },
      { 'codigo': 'LENDO_MENOS', 'texto': 'Estou lendo menos do que antes' },
      { 'codigo': 'SEM_TEMPO_CONTEUDOS_DIGITAIS', 'texto': 'Estou sem tempo para aproveitar os conteúdos digitais' }
    ]
  },
  {
    'codigo': 'EXPECTATIVAS',
    'texto': 'A assinatura não atendeu minhas expectativas',
    'submotivos': [
      { 'codigo': 'GENERO', 'texto': 'Não gostei dos gêneros selecionados' },
      { 'codigo': 'PERFIL_LEITURA', 'texto': 'Os livros não combinam com meu perfil de leitura' }
    ]
  },
  {
    'codigo': 'PROBLEMAS_ASSINATURA',
    'texto': 'Problemas com a assinatura',
    'submotivos': [
      { 'codigo': 'E', 'texto': 'Problemas de entrega' },
      { 'codigo': 'ATENDIMENTO', 'texto': 'Problemas no atendimento' },
      { 'codigo': 'APP_ADA', 'texto': 'Problema na Área do Associado' },
      { 'codigo': 'OUTRO', 'texto': 'Outros' }
    ]
  },
  { 'codigo': 'V', 'texto': 'Vou viajar para fora do país', 'submotivos': [] },
]

export const TITULO_PADRAO = 'Tem certeza que deseja encerrar por aqui?'

export const SUB_PADRAO = 'Você é assinante há {tenure}. Temos ainda muitos países e culturas para conhecer juntos através da literatura.'

export const OFFERS_BY_REASON = {
  'F': {
    'Icon': IcoPlane,
    'listaTitulo': 'Ao renovar, você:',
    'lista': [
      'Economiza R$ 108,00',
      'Ganha frete grátis',
      'Recebe brindes exclusivos: Totebag + Passaporte Literário',
      'Concorre a um sorteio de uma viagem para a Coreia do Sul com acompanhante!'
    ]
  },
  'S': {
    'Icon': IcoHeart,
    'sub': 'Você é assinante há {tenure}. Antes de ir, queremos te lembrar de uma coisa:',
    'h': 'Leia no seu ritmo',
    'p': 'Aqui, você não precisa correr para acompanhar o clube. Os livros ficam na sua estante pelo tempo que precisar. E, quando bater aquela vontade de mergulhar na história, os conteúdos exclusivos ficam disponíveis no nosso Instagram para você acessar quando quiser.',
    'pDestaque': 'Os livros ficam na sua estante pelo tempo que precisar.'
  },
  'EXPECTATIVAS': {
    'Icon': IcoChat,
    'titulo': 'Tem certeza que quer cancelar?',
    'sub': 'Você já faz parte do Clube Bookster há {tenure}. Antes de decidir, veja o que estamos preparando para 2027:',
    'h': '📚 Dos 12 livros, 11 são inéditos no Brasil.',
    'paragrafos': [
      {
        'texto': '🌎 Vamos viajar por diferentes partes do mundo, da Coreia do Sul ao Chile, passando por Líbano, Croácia, Bulgária, Nigéria, Malásia, Austrália, Honduras e outros países.'
      },
      {
        'texto': '✨ Teremos ainda uma obra inédita no Brasil de Buchi Emecheta.',
        'destaques': [ 'obra inédita no Brasil de Buchi Emecheta' ]
      },
      {
        'texto': 'E, como associado, sua renovação também garante benefícios exclusivos: preço especial, frete grátis, totebag e Passaporte Literário.',
        'destaques': [ 'benefícios exclusivos', 'totebag e Passaporte Literário' ]
      }
    ]
  },
  'PROBLEMAS_ASSINATURA': {
    'Icon': IcoPin,
    'h': 'Deixa a gente resolver',
    'p': 'Atualize seu endereço de entrega em segundos e continue recebendo suas edições — sem perder a assinatura.'
  },
  'V': {
    'Icon': IcoPlane,
    'h': 'Faltam poucos países pra fechar o mapa',
    'p': 'Seu próximo carimbo já está sendo preparado pela curadoria. Seria uma pena parar a viagem agora.'
  },
  'MUDANCA_CLUBE': {
    'Icon': IcoChat,
    'h': 'Antes de trocar de clube',
    'p': 'Conta pra gente o que procura na comunidade — talvez a curadoria já consiga te levar pra onde você quer ir.'
  },
  'outro': {
    'Icon': IcoHeart,
    'h': 'Antes de ir…',
    'p': 'Você mantém tempo de assinatura, benefícios e comunidade enquanto estiver no clube.'
  }
}

export const PROBLEMAS_GENERIC_OFFER = {
  'Icon': IcoHeart,
  'h': 'Sentimos muito por essa experiência',
  'p': 'Não era pra ser assim. Vamos registrar o que aconteceu e trabalhar para melhorar a experiência no clube.'
}
